<script setup lang="ts">
import { useRoute, useRouter } from 'vue-router'

import { navigatePortalBack } from '@/utils/navigation'

withDefaults(
  defineProps<{
    label?: string
  }>(),
  {
    label: '返回上一页',
  },
)

defineOptions({ name: 'PortalBackButton' })

const route = useRoute()
const router = useRouter()

const goBack = () => void navigatePortalBack(router, route)
</script>

<template>
  <button
    :aria-label="label"
    class="portal-back-button"
    type="button"
    @click="goBack"
  >
    <svg aria-hidden="true" viewBox="0 0 24 24">
      <path d="M14.5 5 7.5 12l7 7M8 12h9" />
    </svg>
  </button>
</template>

<style scoped>
.portal-back-button.portal-back-button {
  display: inline-grid;
  width: 40px;
  height: 40px;
  padding: 0;
  color: inherit;
  cursor: pointer;
  background: #dedede;
  border: 0;
  border-radius: 50%;
  box-sizing: border-box;
  flex: 0 0 40px;
  font-size: 0;
  line-height: 1;
  place-items: center;
  transition:
    background-color 160ms ease,
    transform 160ms ease;
  -webkit-tap-highlight-color: transparent;
}

.portal-back-button.portal-back-button:active {
  background: #cfcfcf;
  transform: scale(0.96);
}

.portal-back-button.portal-back-button:focus-visible {
  outline: 2px solid currentcolor;
  outline-offset: 2px;
}

.portal-back-button svg {
  width: 23px;
  height: 23px;
  fill: none;
  stroke: currentcolor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 1.8;
}
</style>
